/* eslint-disable linebreak-style */
/* eslint-disable quotes */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable spaced-comment */
import { useEffect, useState } from "react";
import { formatDate } from "../../../common/helpers/dates";
import { SieRedIcon, TvtBlueIcon } from "../../../assets/icons";
import EnergyOfferImage from "../../../assets/images/energy.jpg";
import InternetAndMultimediaImage from "../../../assets/images/internet-and-multimedia.jpg";
import { PAGES } from "../../../common/constants/common";
import trackClickHandler from "../../../common/helpers/trackClickHandler";
// import trackHistory from "../../../common/helpers/trackHistory";
import { appInsightsService } from "../../../services/appInsights/appInsights";
import { Col, Link, Loader, Row, Separator, Text, Title, } from "../../../components/ui";
import ConsumptionGraph from "../../../components/ui/consumptionGraph/ConsumptionGraph";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { fetchContractInfo } from "../../auth/auth.actions";
import { contractInfoSelector, userSelector, } from "../../auth/auth.selectors";
import { INTERNET_COAXAL, INTERNET_OPTIQ, INTERNET_STATUS } from "../../multimedia/myMultimediaOffer/service/myMultimediaOffer.constants";
import { myMultimediaOfferSelector } from "../../multimedia/myMultimediaOffer/service/myMultimediaOffer.selectors";
import styles from "./Dashboard.module.scss";
import { fetchDashboardData } from "./service/dashboard.actions";
import {
  consumptionDashboardSelector,
  isComplexDashboardSelector,
  isFetchingDashboardSelector,
  isFetchingLastInvoiceAndElectricityContractSelector,
  lastInvoiceDashboardSelector,
} from "./service/dashboard.selectors";
import Services from "./Services";
import Newsletter from "./Newsletter";

const Dashboard = () => {
  const location = window.location.href;
  appInsightsService.trackPageView(location);

  const dispatch = useAppDispatch();
  const { scenario, id } = useAppSelector(userSelector);
  const isComplex = useAppSelector(isComplexDashboardSelector);
  const isFetching = useAppSelector(isFetchingDashboardSelector);
  const isFetchingLastInvoiceAndElectricityContract = useAppSelector(isFetchingLastInvoiceAndElectricityContractSelector);
  const lastInvoice = useAppSelector(lastInvoiceDashboardSelector);
  const consumptionData = useAppSelector(consumptionDashboardSelector);
  const contractInfo = useAppSelector(contractInfoSelector);
  const [energyOffer, setEnergyOffer] = useState<string | undefined>();
  const [multimediaOffer, setMultimediaOffer] = useState<string | undefined>();

  // CODE FOR MULTIMEDIA ET INTERNET???
  // const addresses = useAppSelector(myMultimediaOfferSelector);

  useEffect(() => {
    dispatch(fetchDashboardData());
    dispatch(fetchContractInfo());
    return () => {
      // trackHistory(sessionStorage.getItem("clicks") ?? 0, location);
      sessionStorage.removeItem("clicks");
    };
  }, []);

  // Set energy offer in my energy offer
  const myEnergyOffer = () => {
    if (energyOffer?.includes("Nature")) {
      if (energyOffer.includes("+")) {
        return "Vous avez accès à notre offre 50 % énergie hydraulique, 50 % énergie photovoltaïque locale.";
      }
      return "Vous avez accès à notre offre 100 % énergie hydraulique.";
    }
    if (energyOffer === "SIE Basic") {
      return "Vous avez accès à notre offre basique, 100 % énergie nucléaire.";
    }
    if (energyOffer === "SIE Force Hydro EU") {
      return "Vous avez accès à notre offre 100 % énergie hydraulique européenne.";
    }
    if (energyOffer === "SIE Force Hydro +") {
      return "Vous avez accès à notre offre 100 % énergie hydraulique suisse.";
    }
    if (energyOffer === "SIE Personnalisable") {
      return "Vous avez accès à une offre sur mesure pour vos besoins.";
    }

    return "Vous avez accès à une offre sur mesure pour vos besoins.";
  };

  function getLabelStatus(data) {
    return data?.replace(INTERNET_COAXAL.ACTIVE_PARTNER, "Coax: Disponible")
      .replace(INTERNET_COAXAL.LEADED, "Coax: Disponible")
      .replace(INTERNET_OPTIQ.ACTIVE_PARTNER, "Fibre: Disponible");
  }

  useEffect(() => {
    setEnergyOffer(contractInfo?.econtractType);
    setMultimediaOffer(getLabelStatus(contractInfo?.mcontractType));
  }, [contractInfo]);

  if (isFetching && isFetchingLastInvoiceAndElectricityContract) {
    return <Loader />;
  }

  const renderInternetAndMultimediaContent = () => {
    // #1, (TVT Basic, TV+)
    if (multimediaOffer?.includes(INTERNET_COAXAL.ACTIVE_TVT) ||
        multimediaOffer?.includes(INTERNET_COAXAL.ACTIVE_TVT_TV_PLUS)) {
      return (
        <>
          <Text align="center">
            Vous bénéficiez de notre offre multimédia TVT Basic 3 en 1.
          </Text>
          <Separator size="small" />
          <Text align="center">
            Plus d’informations concernant&nbsp;
            <Link
              isTvt
              href={PAGES.MY_MULTIMEDIA_OFFER}
              onClick={trackClickHandler}
            >
              votre raccordement multimédia
            </Link>
            .
          </Text>
          <Separator size="small" />
          <Link
            isTvt
            align="center"
            href="https://www.sie.ch/multimedia/commander-votre-offre/"
            onClick={trackClickHandler}
          >
            Offres promotionnelles (réservées aux nouveaux clients)
          </Link>
        </>
      );
    }

    // #1, (Offre partenaire)
    // if (multimediaOffer?.includes(INTERNET_OPTIQ.ACTIVE_PARTNER) ||
    //     multimediaOffer?.includes(INTERNET_COAXAL.ACTIVE_PARTNER)) {
    //   return (
    //     <>
    //       <Text align="center">
    //         Vous êtes abonné avec les services de notre partenaire.
    //       </Text>
    //       <Separator size="small" />
    //       <Link
    //         isTvt
    //         align="center"
    //         href="https://www.sie.ch/multimedia/commander-votre-offre/"
    //         onClick={trackClickHandler}
    //       >
    //         Actualisez votre offre
    //       </Link>
    //     </>
    //   );
    // }

    // #2, (Fibre optique disponible)
    if (multimediaOffer?.includes(INTERNET_OPTIQ.AVAILABLE)) {
      return (
        <>
          <Text align="center">
            TVT Services propose un service de connexion Internet et multimédia
            via la fibre optique et le raccordement coaxial.
          </Text>
          <Separator size="small" />
          <Text align="center">
            Une connexion Internet 10 Gbit/s disponible à votre adresse.
          </Text>
          <Separator size="small" />
          <Link
            isLight
            align="center"
            className={styles.blue}
            href="https://www.sie.ch/multimedia/commander-votre-offre"
            onClick={trackClickHandler}
          >
            En savoir plus
          </Link>
        </>
      );
    }

    // #2, (Fibre optique disponible)
    if (multimediaOffer?.includes(INTERNET_COAXAL.AVAILABLE)) {
      return (
        <>
          <Text align="center">
            TVT Services propose un service de connexion Internet et multimédia
            via la fibre optique et le raccordement coaxial.
          </Text>
          <Separator size="small" />
          <Text align="center">
            Une connexion Internet 1 Gbit/s disponible à votre adresse.
          </Text>
          <Separator size="small" />
          <Link
            isLight
            align="center"
            className={styles.blue}
            href="https://www.sie.ch/multimedia/commander-votre-offre"
            onClick={trackClickHandler}
          >
            En savoir plus
          </Link>
        </>
      );
    }

    // #4, (Raccordement coaxial (HFC) plombé)
    // if (multimediaOffer?.includes(INTERNET_COAXAL.LEADED)) {
    //   return (
    //     <>
    //       <Text align="center">
    //         TVT Services propose un service de connexion Internet et multimédia
    //         via la fibre optique et le raccordement coaxial.
    //       </Text>
    //       <Separator size="small" />
    //       <Text align="center">
    //         Une connexion Internet 1 Gbit/s disponible à votre adresse.
    //       </Text>
    //       <Separator size="small" />
    //       <Link
    //         isLight
    //         align="center"
    //         className={styles.blue}
    //         href="https://www.sie.ch/multimedia/commander-votre-offre"
    //         onClick={trackClickHandler}
    //       >
    //         Profitez du meilleur divertissement avec TVT
    //       </Link>
    //     </>
    //   );
    // }

    // #5, (Abonnements Multiples)
    if (multimediaOffer?.includes(INTERNET_STATUS.MULTIPLE)) {
      return (
        <>
          <Text align="center">
            Vous profitez de plusieurs abonnements, pour plus de détails rendez-vous à la page
          </Text>
          <Link
            isLight
            to={PAGES.MY_MULTIMEDIA_OFFER}
            onClick={trackClickHandler}
          >
            Raccordements multimédia
          </Link>
        </>
      );
    }

    // #5, (Indisponible)
    return (
      <Text align="center">
        Aucun raccordement n’est disponible à votre adresse. Pour plus
        d’informations, n’hésitez pas&nbsp;
        <Link
          isLight
          className={styles.blue}
          href="https://www.sie.ch/multimedia/commander-votre-offre"
          onClick={trackClickHandler}
        >
          prendre contact avec nous
        </Link>
        .
      </Text>
    );
  };

  const renderEnergieContent = () => {
    if (scenario !== 2 && !isComplex) {
      return (
        <>
          <Title isBoxTitle className={styles.red} level={3}>
            Mon offre énergie
          </Title>
          <Separator />
          <img
            alt="energyOfferImage"
            className={styles.energyOfferImage}
            src={EnergyOfferImage}
          />
          <Separator />
          <Text align="center">
            {myEnergyOffer()}
          </Text>
          <Link
            className={styles.red}
            to={PAGES.MY_ENERGY_OFFER}
            onClick={trackClickHandler}
          >
            En savoir plus
          </Link>
        </>
      );
    }
    return (
      <>
        <Title isBoxTitle className={styles.red} level={3}>
          Mon offre énergie
        </Title>
        <Separator />
        <img
          alt="energyOfferImage"
          className={styles.energyOfferImage}
          src={EnergyOfferImage}
        />
        <Separator />
        <Text align="center">{myEnergyOffer()}</Text>
        <Link
          isLight
          className={styles.red}
          to={PAGES.MY_ENERGY_OFFER}
          onClick={trackClickHandler}
        >
          En savoir plus
        </Link>
      </>
    );
  };

  return (
    <Row align="start" className={styles.dashboard} direction="column">
      <Col>
        <Title>Tableau de bord</Title>
      </Col>
      <Separator />
      <Col span={12}>
        <Row wrapForMobile align="stretch" justify="space-between" wrap={false}>
          {/* BLOCK 1 */}
          <Col isContentBox className={styles.lastInvoice} md={7} span={12}>
            <Title isBoxTitle level={3}>
              Dernière facture
            </Title>
            {lastInvoice?.amount && lastInvoice?.amount !== 0 ? (
              <>
                <Text align="center">
                  Facture pour la dernière période{" "}
                  {formatDate(new Date(lastInvoice?.dueDate), "dd.mm.yyyy")}
                </Text>
                <Title className={styles.invoicePrice}>
                  <>
                    {lastInvoice.amount}
                    <div className={styles.currency}>CHF</div>
                  </>
                </Title>
                <Link
                  isLight
                  className={styles.invoicesLink}
                  to={PAGES.MY_INVOICES}
                  onClick={trackClickHandler}
                >
                  Voir mes factures
                </Link>
              </>
            ) : (
              <Title align="center" className={styles.invoicePrice} level={3}>
                Vous n’avez pas encore de facture disponible.
              </Title>
            )}
          </Col>
          {/* BLOCK 2 */}
          <Col isContentBox md={5} span={12}>
            <Title isBoxTitle level={3}>
              Mes informations client
            </Title>
            <Text>Numéro client : {id}</Text>
            <Separator size="small" />
            <Link
              isLight
              to={PAGES.MY_ENERGY_OFFER}
              onClick={trackClickHandler}
            >
              Offre énergie:
            </Link>
            <Separator size="small" />
            <Text align="center">
              {/* {energyOffer()} */}
              {!energyOffer ? "Aucune" : energyOffer}
            </Text>
            <Separator size="small" />
            <Link
              isLight
              to={PAGES.MY_MULTIMEDIA_OFFER}
              onClick={trackClickHandler}
            >
              Raccordements multimédia:
            </Link>
            <Separator size="small" />
            <Text>
              {multimediaOffer}
              {/* scenario === 0 && "Offre partenaire"}
              {scenario === 1 && "Aucune"}
              {scenario === 2 && "Basic"}
              {scenario === 3 && "Basic"}
              {scenario === 4 && "Offre partenaire" */}
            </Text>
          </Col>
        </Row>
        {/* maximum number of api calls for this page is 5,
        to avoid showing only loader untill everything is loaded, first 2 blocks can be shown after 3 api calls */}
        {isFetching ? (
          <Loader type="content" />
        ) : (
          <>
            <Separator />
            <Row wrapForMobile align="stretch" justify="space-between">
              {/* BLOCK 3 and 4 */}
              <Col className={styles.energieAndConsumptionBox} md={7} span={12}>
                <Row
                  align="start"
                  className={styles.height100}
                  direction="column"
                  justify="start"
                >
                  <SieRedIcon className={styles.sieIcon} />
                  {/* BLOCK 3 */}
                  <Col isContentBox span={12}>
                    {renderEnergieContent()}
                  </Col>
                  {/* BLOCK 4 */}
                  {scenario !== 2 && (
                    <>
                      <Separator size="large" />
                      <ConsumptionGraph data={consumptionData} />
                    </>
                  )}
                </Row>
              </Col>
              {/* BLOCK 5 */}
              <Col md={5} span={12}>
                <Row
                  align="start"
                  className={styles.height100}
                  direction="column"
                  justify="start"
                >
                  <TvtBlueIcon className={styles.tvtIcon} />
                  <Col
                    isContentBox
                    className={styles.internetAndMultimediaBox}
                    span={12}
                  >
                    <Title isBoxTitle className={styles.blue} level={3}>
                      Raccordements multimédia
                    </Title>
                    <Separator />
                    <img
                      alt="internet-and-multimedia"
                      className={styles.internetAndMultimediaImage}
                      src={InternetAndMultimediaImage}
                    />
                    <Separator size="large" />
                    {renderInternetAndMultimediaContent()}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Separator size="large" />
            {/* BLOCK 6 */}
            <Services />
            <Separator size="medium" />
            <Newsletter />
          </>
        )}
      </Col>
    </Row>
  );
};

export default Dashboard;
